import { StatsCards } from "./StatsCards";
import { Card } from "@/components/ui/card";
import { DataTable } from "@/components/ui/data-table";
import { columns } from "@/components/history/columns";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { startOfDay } from "date-fns";

interface BusinessType {
  id: string;
  name: string;
  description?: string;
}

interface OwnerData {
  business_type_id: string;
  company_name: string;
  created_at: string;
  currency: string;
  owner_id: string;
  business_types: BusinessType;
}

interface InterfaceModel {
  id: string;
  name: string;
  description?: string;
  layout: Record<string, any>;
  business_types: {
    id: string;
    name: string;
  };
}

interface OverviewProps {
  ownerData: OwnerData;
  interfaceModel: InterfaceModel;
  sampleData: any[];
}

export const Overview = ({ ownerData, interfaceModel, sampleData }: OverviewProps) => {
  const { data: todayTransactions } = useQuery({
    queryKey: ["today_transactions"],
    queryFn: async () => {
      const startOfToday = startOfDay(new Date());
      
      const { data, error } = await supabase
        .from("poultry_transactions")
        .select(`
          *,
          stock_items (
            data,
            stock_id
          )
        `)
        .gte("created_at", startOfToday.toISOString())
        .order("created_at", { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="space-y-6">
      <div className="w-full overflow-hidden">
        <StatsCards />
      </div>
      
      <div className="grid gap-4">
        <h2 className="text-xl md:text-2xl font-bold">Transactions du jour</h2>
        <Card className="overflow-x-auto">
          <div className="min-w-full">
            {todayTransactions ? (
              <DataTable
                columns={columns}
                data={todayTransactions}
              />
            ) : (
              <div className="p-4 md:p-8 text-center text-muted-foreground">
                Chargement des transactions...
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};